import CornMasaFlourProduct from 'models/CornMasaFlourProduct'

export const cookingTypeOptions = [
  { value: '', label: 'Cooking Type', isDisabled: true },
  { value: 'Regular', label: 'Regular' },
  { value: 'Instant', label: 'Instant' },
]

export const packagingInitialState = {
  category: CornMasaFlourProduct.category,
  subCategory: CornMasaFlourProduct.subCategory,
  CookingType: {
    value: cookingTypeOptions[0].value,
    label: cookingTypeOptions[0].label,
  },
  Size: CornMasaFlourProduct.Size,
}